import loadable from '@loadable/component';

export const TechlearningSiteWrapper = loadable(
  () => import(/* webpackChunkName: "techlearning-site" */ './TechlearningSiteWrapper'),
);
